import React, { useState } from 'react';
import Btn from '../Btn/Btn';
import { download } from '../../utils';

const OneReport = ({ report, fetchReport }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    const data = await fetchReport(report);
    setLoading(false);

    if (data) {
      download({ data, report });
    }
  };

  return (
    <Btn
      tooltipProps={{
        title: `Скачать${report.name ? ` "${report.name}"` : ''}`,
        placement: 'bottomRight',
      }}
      loading={loading}
      onClick={handleClick}
    />
  );
};

export default OneReport;
